import Link from "next/link";
import type { ReactNode } from "react";
import { PrimaryButton, SecondaryButton } from "ui/components";
import { BookIcon, MailIcon } from "ui/iconsN";
import { menuStore } from "../MenuInner";
import { ExtendedLink } from "./ExtendedLink";
import { getTime } from "./getTime";

type Props = {
  catalogueImage: ReactNode;
};
export const Side = ({ catalogueImage }: Props) => (
  <div className="flex flex-col">
    <p className="font-serif text-base text-pr-1 font-medium text-center">Quand souhaitez-vous partir ?</p>
    <div className="flex gap-6 justify-center mt-1.5">
      <div className="flex flex-col gap-1.5">
        <ExtendedLink href={`/recherche/?gte=${getTime(0).start}&lte=${getTime(0).end}`}>Janvier</ExtendedLink>
        <ExtendedLink href={`/recherche/?gte=${getTime(1).start}&lte=${getTime(1).end}`}>Février</ExtendedLink>
        <ExtendedLink href={`/recherche/?gte=${getTime(2).start}&lte=${getTime(2).end}`}>Mars</ExtendedLink>
        <ExtendedLink href={`/recherche/?gte=${getTime(3).start}&lte=${getTime(3).end}`}>Avril</ExtendedLink>
      </div>
      <div className="flex flex-col gap-1.5">
        <ExtendedLink href={`/recherche/?gte=${getTime(4).start}&lte=${getTime(4).end}`}>Mai</ExtendedLink>
        <ExtendedLink href={`/recherche/?gte=${getTime(5).start}&lte=${getTime(5).end}`}>Juin</ExtendedLink>
        <ExtendedLink href={`/recherche/?gte=${getTime(6).start}&lte=${getTime(6).end}`}>Juillet</ExtendedLink>
        <ExtendedLink href={`/recherche/?gte=${getTime(7).start}&lte=${getTime(7).end}`}>Août</ExtendedLink>
      </div>
      <div className="flex flex-col gap-1.5">
        <ExtendedLink href={`/recherche/?gte=${getTime(8).start}&lte=${getTime(8).end}`}>Septembre</ExtendedLink>
        <ExtendedLink href={`/recherche/?gte=${getTime(9).start}&lte=${getTime(9).end}`}>Octobre</ExtendedLink>
        <ExtendedLink href={`/recherche/?gte=${getTime(10).start}&lte=${getTime(10).end}`}>Novembre</ExtendedLink>
        <ExtendedLink href={`/recherche/?gte=${getTime(11).start}&lte=${getTime(11).end}`}>Décembre</ExtendedLink>
      </div>
    </div>
    <div className="w-full h-0.5 bg-bg-2 mt-6" />
    <Link href="/newsletters/" onClick={() => menuStore.set(null)}>
      <SecondaryButton className="mt-6 w-full">
        <MailIcon />
        Recevoir la newsletter
      </SecondaryButton>
    </Link>
    <Link href="/abonnements/" onClick={() => menuStore.set(null)}>
      {catalogueImage}
      <PrimaryButton className="-translate-y-6">
        <BookIcon />
        Demandez votre catalogue
      </PrimaryButton>
    </Link>
  </div>
);
